import {
	ActionIcon,
	AppShellHeader,
	Button,
	Flex,
	Image,
	Menu,
	MenuDropdown,
	MenuItem,
	MenuTarget,
	Popover,
	PopoverDropdown,
	PopoverTarget,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconChevronDown, IconMenu2 } from '@tabler/icons-react'
import { useMemo } from 'react'
import { Link, useParams } from '@tanstack/react-router'
import { mobileWidth } from '@/lib/utility'
import { TwContainer } from '@/lib/components/TwContainer'
import { facilities, useEssentialStore } from '@/layouts/esssential.store'

const HeaderMenu = ({ isMobile, location }: { isMobile?: boolean; location?: string }) => {
	const prefix = useMemo(() => (location ? `/${location}` : ''), [location])
	return (
		<Flex gap={{ md: 'md', xs: '4' }} wrap={'wrap'}>
			<Menu withinPortal withArrow position={'bottom-end'}>
				<MenuTarget>
					<Button c={'gray.7'} variant={'subtle'}>
						Services
					</Button>
				</MenuTarget>
				<MenuDropdown>
					<MenuItem component={Link} to={`${prefix}/services/hiv`}>
						Human Immunodeficiency Virus (HIV)
					</MenuItem>
					<MenuItem component={Link} to={`${prefix}/services/hep-c`}>
						Hepatitis C (HEP-C)
					</MenuItem>
					<MenuItem component={Link} to={`${prefix}/services/prep`}>
						Pre-exposure Prophylaxis (PrEP)
					</MenuItem>
					<MenuItem component={Link} to={`${prefix}/services/pep`}>
						Post-exposure prophylaxis (PEP)
					</MenuItem>
					<MenuItem component={Link} to={`${prefix}/services/sti`}>
						Sexually transmitted infections (STIs)
					</MenuItem>
				</MenuDropdown>
			</Menu>
			<Button c={'gray.7'} component={Link} variant={'subtle'} to={`${prefix}/appointment`}>
				Book an Appointment
			</Button>
			<Menu withinPortal withArrow position={'bottom-end'}>
				<MenuTarget>
					<Button c={'gray.7'} variant={'subtle'}>
						Locations
					</Button>
				</MenuTarget>
				<MenuDropdown>
					{facilities.map((facility) => (
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						<MenuItem component={Link} to={'/$location'} params={{ location: facility.replace(' ', '-') }} key={facility}>
							{facility}
						</MenuItem>
					))}
				</MenuDropdown>
			</Menu>
			<Button c={'gray.7'} component={Link} variant={'subtle'} to={'/about'}>
				About
			</Button>
			{!isMobile ? (
				<Menu>
					<Menu.Target>
						<Button c={'gray.7'} variant={'subtle'}>
							More
							<IconChevronDown size={16} style={{ marginLeft: 4 }} />
						</Button>
					</Menu.Target>
					<Menu.Dropdown>
						<MenuItem component={Link} to={'/gallery'}>
							Gallery
						</MenuItem>
						<MenuItem component={Link} to={'/blog'}>
							Blog
						</MenuItem>
						<MenuItem component={Link} to={'/contact'}>
							Contact Us
						</MenuItem>
						<MenuItem component={Link} to={'/faq'}>
							FAQ
						</MenuItem>
						<MenuItem component={Link} to={'/donate'}>
							Donate
						</MenuItem>
					</Menu.Dropdown>
				</Menu>
			) : (
				<>
					<Button c={'gray.7'} component={Link} variant={'subtle'} to={`${prefix}/gallery`}>
						Gallery
					</Button>
					<Button c={'gray.7'} component={Link} variant={'subtle'} to={`blog`}>
						Blog
					</Button>
					<Button c={'gray.7'} component={Link} variant={'subtle'} to={'/contact'}>
						Contact Us
					</Button>
					<Button c={'gray.7'} component={Link} variant={'subtle'} to={'/faq'}>
						FAQ
					</Button>
					<Button c={'gray.7'} component={Link} variant={'subtle'} to={'/donate'}>
						Donate
					</Button>
				</>
			)}
		</Flex>
	)
}
export const Header = () => {
	const { location } = useParams({ strict: false })
	const isMobile = useMediaQuery(mobileWidth)
	const essentialStore = useEssentialStore()
	return (
		<AppShellHeader className="bg-white w-full z-50 h-fit sticky top-0  px-4  border-0">
			<TwContainer row className="flex justify-between text-white md:py-5 py-2 items-center" md>
				<Link to={'/'}>
					<Image className={'left-0'} src={essentialStore.logo} alt={essentialStore.name} h={40} w={120} />
				</Link>
				{isMobile == false ? (
					<HeaderMenu isMobile={isMobile} location={location} />
				) : (
					<Popover closeOnClickOutside={false}>
						<PopoverTarget>
							<ActionIcon aria-label={'Menu'} aria-labelledby={'Menu'} color={'brand.9'} variant={'transparent'}>
								<IconMenu2 />
							</ActionIcon>
						</PopoverTarget>
						<PopoverDropdown className={'max-w-full'}>
							<HeaderMenu isMobile={isMobile} location={location} />
						</PopoverDropdown>
					</Popover>
				)}
			</TwContainer>
		</AppShellHeader>
	)
}
